import PageIntroduction from "./PageIntroduction"


const GreenHeader = ({title, details}) => {
   return (
    <div className='green-header'>
        <PageIntroduction title={title} details={details}/>
    </div>
  )
}
export default GreenHeader